export default __webpack_public_path__ + "static/media/ubuntu_icon.18147035.png";